"use client";

import BlogGrid1 from "@components/elements/blog/BlogGrid1";
import Pagination from "@components/elements/Pagination";
import SectionTitle from "@components/elements/SectionTitle";
import Layout from "@components/layout/landing/Layout";
import NewsletterSection1 from "@components/sections/newsletter/Newsletter1";
import AdSense from "@components/elements/AdSense";
import { URL } from "@constants/path";
import { BLOG_FILTER } from "@constants/variables";
import fetchApi from "@hooks/useFetch";
import { useEffect, useState } from "react";
import React from "react";

const Blog = ({ pages, blog, filterOption, meta }) => {
  const currentPage = pages.find(item => item.id === 66);
  const [perPage, setPerPage] = useState(12);
  const [totalItems, setTotalItems] = useState(blog?.length || 0);
  const [filter, setFilter] = useState({ ...BLOG_FILTER });
  const [article, setArticle] = useState(blog);

  const onPageChanged = (currentPage) => {
    let newFilter = { ...filter };
    newFilter.page = currentPage;
    setFilter(newFilter);
  };

  useEffect(() => {
    fetchApi(URL.BLOG, "POST", {
      is_api: 1,
      option_value: filterOption,
      ...filter,
    }).then((res) => {
      setArticle(res);
    });

  }, [filter]);

  return (
    <>
      <Layout
        breadcrumbTitle={meta?.h1 ? meta?.h1 : currentPage?.title}
        breadcrumbSubTitle={meta?.seo_meta_description ? meta?.seo_meta_description : currentPage?.seo_title}
        breadcrumbAlign={"center"}
        headerBg={"transparent"}
        pages={pages}
      >
        <div className="pt-12">
          <div className="container"> 
            <SectionTitle
              style={5}
              description={meta?.description}
            />
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
            {article.map((item, i) => {
                // Insérer l'AdSense à la 6ème position (index 5) et décaler l'article suivant
                if (i === 5) {
                  return (
                    <React.Fragment key={`adsense-${i}`}>
                      <AdSense 
                        adSlot="4375594741" 
                        adFormat="fluid"
                        adLayout="-69+dw+18-3h+8r"
                        className="blog-adsense"
                      />
                      <BlogGrid1 item={item} key={i} currentPage={currentPage} />
                    </React.Fragment>
                  );
                }
                return <BlogGrid1 item={item} key={i} currentPage={currentPage} />;
              })}           
            </div>
            <Pagination
              totalItems={totalItems}
              perPage={perPage}
              onPageChanged={onPageChanged}
            />
          </div>
        </div>
        <NewsletterSection1 />
      </Layout>
    </>
  );
};

export default Blog;
